import { createSlice } from "@reduxjs/toolkit";
import { ILocation } from "../interface/ILocation";

const initialState: ILocation | null = null;

const locationScheme = createSlice({
    name: "locationSchem",
    initialState,
    reducers: {
        setlocationSchemeInStore: (state, action) => {
            return action.payload;
        },
        addSeatLocationSchemeInStore: (state : any, action : any) => {
            if (!state){
                return;
            }
            return {
                ...state,
                sectors: state.sectors.map((sector : any) => {
                    return {
                        ...sector,
                        seats: Array.isArray(sector.seats) ? [...sector.seats, ...(Array.isArray(action.payload) ? action.payload : [action.payload])] : (Array.isArray(action.payload) ? action.payload : [action.payload])
                    };
                })
            };
        },
        deleteSeatLocationSchemeInStore: (state : any, action : any) => {
            return {
                ...state,
                sectors: state.sectors.map((sector : any) => {
                    return {
                        ...sector,
                        seats: Array.isArray(sector.seats) ? sector.seats.filter((seat : any) => !action.payload.includes(seat.id)) : []
                    }
                })
            }
        }
    },
});

export const { setlocationSchemeInStore, addSeatLocationSchemeInStore, deleteSeatLocationSchemeInStore } = locationScheme.actions;

export default locationScheme.reducer;
